import { VideoModel } from '../../api/video';
const GB = 1024 * 1024 * 1024;
const MAX_VIDEO_SIZE = 3 * GB;

const vodVideo = function(video) {
  if (video instanceof VideoModel && video.file.size > MAX_VIDEO_SIZE) {
    return 'size should be less than 3GB.';
  }
};

export default vodVideo;



// WEBPACK FOOTER //
// ./src/utilites/validate/vodVideo.js